import api from "./api";

export interface Principal {
  id: string;
  name: string;
  role: string;
  photo_url: string | null;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PrincipalListResponse {
  total: number;
  items: Principal[];
}

export const principalsService = {
  list: async (): Promise<PrincipalListResponse> => {
    const { data } = await api.get<PrincipalListResponse>("/principals");
    return data;
  },
};
